module.exports = __webpack_public_path__ + "static/media/map.000880a3.svg";